export default __webpack_public_path__ + "static/media/V280MANB2.0c80a41b.pdf";